import ClassesList from "./components/ClassesList";
import PackagesList from "./components/PackagesList";
import AdminsList from "./components/AdminsList";
import StudentsList from "./components/StudentsList";
import Calendar from "./components/Calendar";
import EditEvent from './components/EditEvent';
import AddEvent from './components/AddEvent';
import Configuration from "./components/Configuration";

// @mui icons
import Icon from "@mui/material/Icon";
import TableViewIcon from '@mui/icons-material/TableView';
import BackupTableTwoToneIcon from '@mui/icons-material/BackupTableTwoTone';
import EventNoteTwoToneIcon from '@mui/icons-material/EventNoteTwoTone';
import PeopleAltTwoToneIcon from '@mui/icons-material/PeopleAltTwoTone';
import GroupsIcon from '@mui/icons-material/Groups';
import SubjectIcon from '@mui/icons-material/Subject';
import SettingsApplicationsIcon from '@mui/icons-material/SettingsApplications';


const routes = [
  {
    name: "Classes",
    key: "classes",
    icon: <Icon fontSize="small" component={TableViewIcon}/>,
    link: "/classes",
    component: <ClassesList />,
    adminFlag:false,
    staffFlag:true,
    leftMenuFlag:true,
  },
  {
    name: "Packages",
    key: "packages",
    icon: <Icon fontSize="small" component={BackupTableTwoToneIcon}/>,
    link: "/packages",
    component: <PackagesList />,
    adminFlag:false,
    staffFlag:true,
    leftMenuFlag:true,
  },
  {
    name: "Calendar",
    key: "calendar",
    icon: <Icon fontSize="small" component={EventNoteTwoToneIcon}/>,
    link: "/calendar",
    component:<Calendar /> ,
    adminFlag:false,
    staffFlag:false,
    leftMenuFlag:true,
  },
  {
    name: "Students",
    key: "students",
    icon: <Icon fontSize="small" component={GroupsIcon}/>,
    link: "/students",
    component: <StudentsList />,
    adminFlag:false,
    staffFlag:true,
    leftMenuFlag:true,
  },
  {
    name: "Staff",
    key: "admins",
    icon: <Icon fontSize="small" component={PeopleAltTwoToneIcon}/>,
    link: "/admins",
    component: <AdminsList />,
    adminFlag:true,
    staffFlag:true,
    leftMenuFlag:true,    
  },
  {
    name: "Reports",
    key: "reports",
    icon: <Icon fontSize="small" component={SubjectIcon}/>,
    link: "/reports",
    component: <AdminsList />,
    adminFlag:false,
    staffFlag:true,
    leftMenuFlag:true,    
  },
  {
    name: "Configuration",
    key: "config",
    icon: <Icon fontSize="small" component={SettingsApplicationsIcon}/>,
    link: "/config",
    component: <Configuration />,
    adminFlag:true,
    staffFlag:true,
    leftMenuFlag:true,    
  },
  {
    name: "calendar",
    key: "calendar",
    icon: <Icon fontSize="small" component={EventNoteTwoToneIcon}/>,
    link: "calendar/:day",
    component: <Calendar />,
    adminFlag:false,
    leftMenuFlag:false,
  },
  {
    name: "Add Event",
    key: "addEvent",
    icon: <Icon fontSize="small" component={TableViewIcon}/>,
    link: "calendar/:day/new",
    component: <AddEvent />,
    adminFlag:false,
    leftMenuFlag:false,
  },
  {
    name: "Edit Event",
    key: "editEvent",
    icon: <Icon fontSize="small" component={TableViewIcon}/>,
    link: "calendar/:day/:event",
    component: <EditEvent />,
    adminFlag:false,
    leftMenuFlag:false,
  },

  /*{
    name: "Notifications",
    key: "notifications",
    icon: <Icon fontSize="small">notifications</Icon>,
    route: "/notifications",
    component: <Notifications />,
  },
  {
    name: "Profile",
    key: "profile",
    icon: <Icon fontSize="small">person</Icon>,
    route: "/profile",
    component: <Profile />,
  },
  {
    name: "Sign In",
    key: "sign-in",
    icon: <Icon fontSize="small">login</Icon>,
    route: "/authentication/sign-in",
    component: <SignIn />,
  },
  {
    name: "Sign Up",
    key: "sign-up",
    icon: <Icon fontSize="small">assignment</Icon>,
    route: "/authentication/sign-up",
    component: <SignUp />,
  },*/
];

export default routes;
